import React from "react";
import { Logo, AboutUs, Flex } from "../assets";
import Header from "./Header";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCode } from "react-icons/fa6";

const About = () => {
  return (
    <div className="mt-[2rem] min-h-screen">
      <Header title="Who We Are" subtitle="Our story and what drives us" />
      <div className="flex justify-between gap-[50px] lg:gap-[130px] xl:gap-0 flex-col lg:flex-row">
        <div className="relative w-3/4 lg:w-1/2 xl:w-[770px] z-10 order-2 lg:order-1">
          <img src={AboutUs} alt="" />
          <div className="absolute z-20 bottom-4 w-[200px] md:w-[300px] right-[-30%] md:right-[-7%} lg:right-[22%] border-2 border-br">
            <img src={Logo} alt="" />
          </div>
          <div className="w-[150px] lg:w-[250px] rounded-[6px] bg-white border-2 border-br absolute bottom-[50px] left-0 md:bottom-[100px] md:left-5 z-20 p-2 pb-3 lg:pt-4 l:pb-[26px] rounded[10px]">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-[6px] lg:gap-3">
              <p className="text-[10px] leading-[10px] lg:text-[14px] lg:leading-5 text-dr_gray font-[400]">
                Tue, 24
              </p>
              <p className="text-[10px] leading-[10px] lg:text-[14px] lg:leading-5 text-dr_gray font-[400]">
                10:00AM
              </p>
            </div>
            <span className="w-5 h-5 lg:w-[34px] lg:h-[34px] flex items-center justify-center bg-h5 text-dr_gray rounded py-1 px-[6px] lg:py-3 lg:px-[9px]">
              <FaCode size={18} />
            </span>
          </div>

          <div className="w-max bg-br py-1 px-2 lg:py-[6px] lg:px-[10px] text-[8px] leading-[8px] lg:text-[12px] lg:leading-4 text-dr_gray rounded-md">
            Sofware Development
          </div>

          <div className="flex items-center gap-[6px] lg:gap-[10px] mt-2 lg:mt-[18px]">
            <img src={Flex} className="w-[40px] h-[40px] rounded-full object-contain" alt="" />
            <h4 className="text-[10px] leading-3 lg:text-[16px] lg:leading-[22px] font-[700] text-dr_gray">
              Flex
            </h4>
          </div>
        </div>
        </div>
        <div className="w-full lg:w-1/2 xl:w-[670px] order-1 lg:order-2">
          <p className="text__para">
            Welcome to Flex – a collective of dynamic, innovative tech
            enthusiasts coming together with a shared passion for solving
            challenges and making a positive impact on the world. <br />
            <br />
            Our diverse team brings together their unique skills in testing,
            designing, developing, and tackling complex problems.
            <br />
            <br />
            Though we hail from different backgrounds, we share a common goal,
            And that's what set us apart.Using our skills to address global
            issues and contribute to making the world a better place.
            <br />
            <br />
            Join us on this journey as we leverage our collective expertise to
            create meaningful solutions and shape a brighter future.
          </p>
          <div className="flex flex-col items-center justify-center mt-10 font-semibold">
            <Link to="/sign-in" className="btn btn-secondary rounded-md mx-aut text-dr_gray">Join us
              <FaArrowRight size={18} className="text-dr_gray" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
